import { client } from "../client/client";

export const generateAdminAccountStatement = async (
  startDate,
  endDate,
  userId,
  accountId
) => {
  try {
    const response = await client.post(`/api/v1/statement/admin`, {
      account_id: accountId,
      start_date: startDate,
      end_date: endDate,
      user_id: userId,
    });
    return response
  } catch (error) {
    throw error?.response?.data || error;
  }
};
